import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'carnivore-diet-female',
	landing: {
		ids: ['loader-carnivore-diet-gs'],
		route: {
			path: '/carnivore-diet-f',
			name: 'carnivore-diet-female-funnel',
		},
	},
	funnel: {
		id: 'ob-carnivore-diet-female',
		route: {
			path: '/carnivore-diet-f/ob/:page(.*)?',
			name: 'carnivore-diet-female',
		},
		slug: 'carnivore-diet-female',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-carnivore-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
}

export default appAreaConfig
